/** What a form holds after a building-type row has been consulted for a limit. */
export type AppliedLimit = { next: number | null; fromRow: boolean };

// A row number always wins. When the row has none, only a number this form resolved earlier is cleared,
// so a stored or typed limit survives a remount while a changed building type still drops its predecessor's.
export const applyResolvedLimit = (
  resolved: number | null | undefined,
  current: number | null,
  previousFromRow: boolean
): AppliedLimit => {
  if (resolved) return { next: resolved, fromRow: true };
  // A stored 0 is the column's "no limit set", so it reads back as the empty, still-required field it was.
  return { next: previousFromRow || current === 0 ? null : current, fromRow: false };
};
